import _Object$entries from 'babel-runtime/core-js/object/entries';
import _typeof from 'babel-runtime/helpers/typeof';
/**
 * @param {function} fn
 * @param {any} init
 * @param {any} coll
 * @returns {any}
 */

function reduce(fn, init, coll) {
  if (coll.reduce && typeof coll.reduce === 'function') {
    return coll.reduce(fn, init);
  }

  if (coll.length && typeof coll.length === 'number') {
    var length = coll.length;
    var result = init;

    for (var i = 0; i < length; i++) {
      result = fn(result, coll[i]);
    }

    return result;
  }

  if ((typeof coll === 'undefined' ? 'undefined' : _typeof(coll)) === 'object' && coll !== null) {
    return _Object$entries(coll).reduce(fn, init);
  }

  return fn(init, coll);
}

export default reduce;